import { ReactElement, useState } from "react";
import { TitleRow } from "./TitleRow";

export const Grid: React.FC<{
  title?: string;
  itemCount: number;
  rows: ReactElement | null;
}> = ({ rows, title, itemCount }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  return (
    rows && (
      <group
        data-width="auto"
        data-wrap="no"
        data-direction="column"
        data-name="grid_row"
      >
        {title && (
          <TitleRow
            title={title}
            itemCount={itemCount}
            isExpanded={isExpanded}
            toggle={() => setIsExpanded((prev) => !prev)}
          />
        )}
        {isExpanded && (
          <group
            data-name="grid_container"
            data-width="auto"
            data-direction="column"
          >
            {rows}
          </group>
        )}
      </group>
    )
  );
};
